import React, { useState } from "react";
import Table from "../comman/table";
import BrowserDetails from "./BrowserDetails";
import LocationDetails from "./LocationDetails";

const LogsTable = ({ data }) => {
  const [selectedData, setSelectedData] = useState(null);
  const [modalType, setModalType] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = (type, rowData) => {
    setSelectedData(rowData);
    setModalType(type);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedData(null);
    setModalType("");
  };

  const columns = [
    { path: "id", label: "ID" },
    { path: "userid", label: "User ID" },
    { path: "userName", label: "User Name" },
    { path: "loginDateTime", label: "Login Date & Time" },
    { path: "ipAddress", label: "IP Address" },
    { path: "country", label: "Country" },
    { path: "logoutDateTime", label: "Logout DateTime" },
    {
      path: "",
      label: "Location Details",
      content: (row) => (
        <button
          type="button"
          className="btn btn-link btn-sm"
          onClick={() => handleOpenModal("location", row)}
        >
          <i className="fa fa-eye" aria-hidden="true"></i>
        </button>
      ),
    },
    {
      path: "",
      label: "Browser Details",
      content: (row) => (
        <button
          type="button"
          className="btn btn-link btn-sm"
          onClick={() => handleOpenModal("browser", row)}
        >
          <i className="fa fa-eye" aria-hidden="true"></i>
        </button>
      ),
    },
  ];

  return (
    <>
      <Table columns={columns} data={data} />

      {modalType === "location" &&
        <LocationDetails
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          data={selectedData}
        />
      }

      {modalType === "browser" &&
        <BrowserDetails
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          data={selectedData}
        />
      }

    </>
  );
};

export default LogsTable;
